<template>
    <div class="scratch-game">
        <!-- Bannière -->
        <div class="banner-container">
            <img :src="imgUrl($mecanic.scratch_picture, 'scratch')" :alt="'Bannière jeu à gratter'"
                class="banner-desktop hidden lg:block w-[70%] mx-auto" />
            <img :src="imgUrl($mecanic.scratch_picture_mobile, 'scratch')" :alt="'Bannière jeu à gratter mobile'"
                class="banner-mobile block lg:hidden w-[80%] mx-auto" />
        </div>

        <!-- Texte en dessous bannière -->
        <div v-if="$mecanic.text_scratch" class="text-scratch text-center my-4" v-html="$mecanic.text_scratch">
        </div>

        <!-- Instructions -->
        <div
            class="p-6 my-6 md:my-8 rounded-lg shadow flex flex-col md:flex-row items-center gap-4 bg-black/30 rounded-xl backdrop-blur-sm">
            <div
                class="text-3xl font-bold w-[200px] md:w-[20%] text-[#EDC516] uppercase border-b-4 md:border-r-4 md:border-b-0 border-[#EDC516] pl-4 pb-2 md:pl-4 md:pb-0 italic">
                <p>Comment</p>
                <p>jouer ?</p>
            </div>
            <div class="flex flex-col md:flex-row items-center w-full md:w-[80%] gap-4">
                <div v-if="$mecanic.instructions_1_scratch"
                    class="instruction-item flex items-center w-full md:w-[33%]">
                    <p class="instruction-number">
                        1</p>
                    <p class="!text-white force-white-html font-bold" v-html="$mecanic.instructions_1_scratch"></p>
                </div>
                <div v-if="$mecanic.instructions_2_scratch"
                    class="instruction-item flex items-center w-full md:w-[33%]">
                    <p class="instruction-number">
                        2</p>
                    <p class="!text-white force-white-html font-bold" v-html="$mecanic.instructions_2_scratch"></p>
                </div>
                <div v-if="$mecanic.instructions_3_scratch"
                    class="instruction-item flex items-center w-full md:w-[33%]">
                    <p class="instruction-number">
                        3</p>
                    <p class="!text-white force-white-html font-bold" v-html="$mecanic.instructions_3_scratch"></p>
                </div>
            </div>
        </div>

        <!-- Zone de jeu -->
        <div class="game-container my-4 rounded-lg">
            <div class="lg:flex lg:gap-6">
                <!-- Combinaisons gagnantes (à gauche) -->
                <div
                    class="border-4 border-[#EDC516] lg:w-1/2 mb-6 lg:mb-0 p-4 rounded-xl h-[400px] md:h-[500px] bg-black/20">
                    <h4
                        class="text-3xl font-bold mb-4 md:mb-6 text-center uppercase text-[#EDC516] border-b-2 border-[#EDC516] pb-2">
                        Combinaisons gagnantes</h4>
                    <div class="h-[250px] md:h-[350px] flex flex-col justify-between">
                        <div v-if="$mecanic.amount_1_scratch">
                            <p class="combinaison-text">3 dés identiques</p>
                            <div class="flex items-center justify-center gap-2">
                                <img src="@/assets/img/scratch/dice_2.png" alt="" class="dice-style-small">
                                <img src="@/assets/img/scratch/dice_2.png" alt="" class="dice-style-small">
                                <img src="@/assets/img/scratch/dice_2.png" alt="" class="dice-style-small">
                                <div class="font-bold text-[#EDC516] text-3xl"> = {{ $mecanic.amount_1_scratch }} €
                                </div>
                            </div>
                        </div>

                        <div v-if="$mecanic.amount_2_scratch">
                            <p class="combinaison-text">4, 5 et 6 combinés</p>
                            <div class="flex items-center justify-center gap-2">
                                <img src="@/assets/img/scratch/dice_4.png" alt="" class="dice-style-small">
                                <img src="@/assets/img/scratch/dice_5.png" alt="" class="dice-style-small">
                                <img src="@/assets/img/scratch/dice_6.png" alt="" class="dice-style-small">
                                <div class="font-bold text-[#EDC516] text-3xl"> = {{ $mecanic.amount_2_scratch }} €
                                </div>
                            </div>
                        </div>

                        <div v-if="$mecanic.amount_3_scratch">
                            <p class="combinaison-text">3 dés avec six points</p>
                            <div class="flex items-center justify-center gap-2">
                                <img src="@/assets/img/scratch/dice_6.png" alt="" class="dice-style-small">
                                <img src="@/assets/img/scratch/dice_6.png" alt="" class="dice-style-small">
                                <img src="@/assets/img/scratch/dice_6.png" alt="" class="dice-style-small">
                                <div class="font-bold text-[#EDC516] text-3xl"> = {{ $mecanic.amount_3_scratch }} €
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Zones à gratter (à droite) -->
                <div
                    class="lg:w-1/2 rounded-xl bg-white h-[400px] md:h-[500px] border-4 border-[#EDC516] bg-[#FDE68A] p-3 relative">
                    <img src="@/assets/img/scratch/free_game.png" alt=""
                        class="absolute w-[120px] lg:w-[140px] -top-[30px] -left-[30px] z-20">
                    <div class="rounded-xl p-4 h-full bg-white flex flex-col justify-between gap-2 md:gap-4">
                        <div :class="{ 'zone-inactive': currentZone !== 0 && !scratchedZones[0] }">
                            <div
                                class="scratch-area-container relative bg-white rounded-lg p-4 md:p-6 border-2 border-gray-700">
                                <div class="dice-background flex justify-center gap-4 md:gap-8">
                                    <img src="@/assets/img/scratch/dice_1.png" alt="" class="dice-style">
                                    <img src="@/assets/img/scratch/dice_4.png" alt="" class="dice-style">
                                    <img src="@/assets/img/scratch/dice_2.png" alt="" class="dice-style">
                                </div>
                                <canvas v-show="!scratchedZones[0]" ref="scratchCanvas0"
                                    class="scratch-canvas absolute inset-0 cursor-crosshair"
                                    @mousedown="startScratching(0, $event)" @mousemove="scratch(0, $event)"
                                    @mouseup="stopScratching" @mouseleave="stopScratching"
                                    @touchstart="startScratching(0, $event)" @touchmove="scratch(0, $event)"
                                    @touchend="stopScratching"></canvas>
                            </div>
                        </div>

                        <div :class="{ 'zone-inactive': currentZone !== 1 && !scratchedZones[1] }">
                            <div
                                class="scratch-area-container relative bg-white rounded-lg p-4 md:p-6 border-2 border-gray-700 overflow-hidden">
                                <div class="dice-background flex justify-center gap-4 md:gap-8">
                                    <img src="@/assets/img/scratch/dice_5.png" alt="" class="dice-style">
                                    <img src="@/assets/img/scratch/dice_3.png" alt="" class="dice-style">
                                    <img src="@/assets/img/scratch/dice_4.png" alt="" class="dice-style">
                                </div>

                                <canvas v-show="!scratchedZones[1]" ref="scratchCanvas1"
                                    class="scratch-canvas absolute inset-0 cursor-crosshair"
                                    @mousedown="startScratching(1, $event)" @mousemove="scratch(1, $event)"
                                    @mouseup="stopScratching" @mouseleave="stopScratching"
                                    @touchstart="startScratching(1, $event)" @touchmove="scratch(1, $event)"
                                    @touchend="stopScratching"></canvas>

                                <img v-if="!scratchedZones[1]" :src="scratchImages[1].blocked" class="blocked-overlay"
                                    :class="{ 'fade-out': currentZone >= 1 }" alt="Zone bloquée">
                            </div>
                        </div>

                        <div :class="{ 'zone-inactive': currentZone !== 2 && !scratchedZones[2] }">
                            <div
                                class="scratch-area-container relative bg-white rounded-lg p-4 md:p-6 border-2 border-gray-700 overflow-hidden">
                                <div class="dice-background flex justify-center gap-4 md:gap-8">
                                    <img src="@/assets/img/scratch/dice_6.png" alt="" class="dice-style">
                                    <img src="@/assets/img/scratch/dice_6.png" alt="" class="dice-style">
                                    <img src="@/assets/img/scratch/dice_6.png" alt="" class="dice-style">
                                </div>

                                <canvas v-show="!scratchedZones[2]" ref="scratchCanvas2"
                                    class="scratch-canvas absolute inset-0 cursor-crosshair"
                                    @mousedown="startScratching(2, $event)" @mousemove="scratch(2, $event)"
                                    @mouseup="stopScratching" @mouseleave="stopScratching"
                                    @touchstart="startScratching(2, $event)" @touchmove="scratch(2, $event)"
                                    @touchend="stopScratching"></canvas>

                                <img v-if="!scratchedZones[2]" :src="scratchImages[2].blocked" class="blocked-overlay"
                                    :class="{ 'fade-out': currentZone >= 2 }" alt="Zone bloquée">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div v-if="gameFinished" ref="endGameSection" class="w-full flex flex-col justify-center mt-4"
        style="scroll-margin-top: 500px;">
        <p class="mb-4" v-html="$mecanic.end_text_scratch"></p>
        <p class="m-auto w-fit sm:mt-4 font-bold text-[14px] lg:text-[24px]">Voici votre numéro de participation</p>
        <CodeTable v-if="code" :code="code" />
    </div>
</template>


<script>
// Importation des images
import imgLancer1 from '@/assets/img/scratch/1_lancer.png';
import imgLancer2 from '@/assets/img/scratch/2_lancer.png';
import imgLancer2b from '@/assets/img/scratch/2_lancer_b.png';
import imgLancer3 from '@/assets/img/scratch/3_lancer.png';
import imgLancer3b from '@/assets/img/scratch/3_lancer_b.png';
import CodeTable from './CodeTable.vue'

export default {
    name: 'ScratchGame',
    emits: ['endGame'],
    components: {
        CodeTable
    },
    props: {
        code: String
    },
    data() {
        return {
            scratchedZones: [false, false, false],
            gameFinished: false,
            isScratching: false,
            currentZone: 0,
            scratchThreshold: 70, // % nécessaire pour valider
            scratchImages: {
                0: { active: imgLancer1, blocked: null },
                1: { active: imgLancer2, blocked: imgLancer2b },
                2: { active: imgLancer3, blocked: imgLancer3b }
            }
        }
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.$nextTick(() => this.handleResize());
    },
    methods: {
        handleResize() {
            this.initCanvas(0, this.scratchImages[0].active);
            this.initCanvas(1, this.scratchImages[1].active);
            this.initCanvas(2, this.scratchImages[2].active);
        },

        initCanvas(zoneIndex, imageUrl) {
            const canvas = this.$refs[`scratchCanvas${zoneIndex}`];
            if (!canvas) return;

            const rect = canvas.parentElement.getBoundingClientRect();
            canvas.width = rect.width;
            canvas.height = rect.height;

            const ctx = canvas.getContext('2d', { willReadFrequently: true });
            ctx.globalCompositeOperation = 'source-over';

            // Dessiner immédiatement un fond gris pour masquer les dés
            ctx.fillStyle = '#9AABA7'; // Même couleur que .scratch-area-container
            ctx.fillRect(0, 0, canvas.width, canvas.height);

            const img = new Image();
            img.src = imageUrl;
            img.onload = () => {
                // Effacer le fond temporaire
                ctx.clearRect(0, 0, canvas.width, canvas.height);

                // --- ALGORITHME "OBJECT-FIT: COVER" POUR CANVAS ---

                // 1. Calculer le ratio pour que l'image remplisse tout le canvas sans déformation
                const scale = Math.max(canvas.width / img.width, canvas.height / img.height);

                // 2. Calculer les nouvelles dimensions
                const x = (canvas.width / 2) - (img.width / 2) * scale;
                const y = (canvas.height / 2) - (img.height / 2) * scale;

                // 3. Dessiner l'image centrée et redimensionnée proportionnellement
                ctx.drawImage(img, x, y, img.width * scale, img.height * scale);
            };
        },

        startScratching(zoneIndex, event) {
            // Empêche de gratter si ce n'est pas la zone active
            if (zoneIndex !== this.currentZone) return;

            // Vérifier clic gauche souris
            if (event.type === 'mousedown' && event.button !== 0) return;

            // Empêcher le scroll sur mobile
            if (event.type === 'touchstart') {
                event.preventDefault();
            }

            this.isScratching = true;

            if (event.type === 'mousedown') {
                document.addEventListener('mouseup', this.stopScratching, { once: true });
                document.addEventListener('mouseleave', this.stopScratching, { once: true });
            }

            this.scratch(zoneIndex, event);
        },

        scratch(zoneIndex, event) {
            if (!this.isScratching || zoneIndex !== this.currentZone) return;

            if (event.type === 'mousemove' && event.buttons !== 1) {
                this.stopScratching();
                return;
            }

            const canvas = this.$refs[`scratchCanvas${zoneIndex}`];
            if (!canvas) return;

            const ctx = canvas.getContext('2d', { willReadFrequently: true });
            const rect = canvas.getBoundingClientRect();

            let clientX, clientY;
            if (event.touches && event.touches[0]) {
                clientX = event.touches[0].clientX;
                clientY = event.touches[0].clientY;
                // Empêcher le scroll sur mobile pendant le grattage
                event.preventDefault();
            } else {
                clientX = event.clientX;
                clientY = event.clientY;
            }

            const x = clientX - rect.left;
            const y = clientY - rect.top;

            // Mode "gomme" pour rendre transparent
            ctx.globalCompositeOperation = 'destination-out';
            ctx.beginPath();

            // Taille du pinceau adaptée selon la taille d'écran
            const brushSize = window.innerWidth >= 1024 ? 35 : 25; // Plus gros sur desktop (35px vs 20px)
            ctx.arc(x, y, brushSize, 0, 2 * Math.PI);
            ctx.fill();

            this.checkScratchProgress(zoneIndex);
        },

        stopScratching() {
            this.isScratching = false;
            document.removeEventListener('mouseup', this.stopScratching);
            document.removeEventListener('mouseleave', this.stopScratching);
        },

        checkScratchProgress(zoneIndex) {
            const canvas = this.$refs[`scratchCanvas${zoneIndex}`];
            if (!canvas) return;

            const ctx = canvas.getContext('2d', { willReadFrequently: true });

            // Attention : getImageData peut échouer si l'image vient d'un autre domaine (CORS)
            // Mais ici ce sont des assets locaux donc ça devrait aller.
            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            const pixels = imageData.data;

            let transparentPixels = 0;
            // On vérifie le canal Alpha (4ème octet) de chaque pixel
            for (let i = 3; i < pixels.length; i += 4) {
                if (pixels[i] === 0) {
                    transparentPixels++;
                }
            }

            const totalPixels = pixels.length / 4;
            const scratchPercentage = (transparentPixels / totalPixels) * 100;

            if (scratchPercentage >= this.scratchThreshold) {
                this.completeZone(zoneIndex);
            }
        },

        completeZone(zoneIndex) {
            this.scratchedZones[zoneIndex] = true;

            if (zoneIndex < 2) {
                // SIMPLIFICATION MAJEURE :
                // On change juste l'index. C'est le CSS qui va gérer la transition fluide
                // en faisant disparaître l'image bloquée grâce à la condition dans le template.
                this.currentZone = zoneIndex + 1;
            } else {
                this.gameFinished = true;
                this.$emit('endGame', true);

                // Scroll vers la section finale après un court délai pour laisser le temps au DOM de se mettre à jour
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.$refs.endGameSection?.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        });
                    }, 500); // Délai de 500ms pour une meilleure UX
                });
            }
        },
    },
}
</script>

<style scoped>
.scratch-game {
    background-image: v-bind("$mecanic?.background_scratch ? `url(${imgUrl($mecanic.background_scratch, 'scratch')})` : 'none'");
    /* background-size: cover; */
    background-position: center;
    min-height: 100vh;
    @apply p-4 md:p-6 bg-auto md:bg-cover
}

@media (max-width: 1024px) {
    .scratch-game {
        background-image: v-bind("$mecanic?.background_scratch_mobile ? `url(${imgUrl($mecanic.background_scratch_mobile, 'scratch')})` : ($mecanic?.background_scratch ? `url(${imgUrl($mecanic.background_scratch, 'scratch')})` : 'none')");
    }
}

.scratch-area-container {
    position: relative;
    background-color: #9AABA7;
    @apply flex items-center justify-center min-h-[100px] md:min-h-[120px]
}

.zone-inactive {
    opacity: 0.6;
    pointer-events: none;
}

.dice-background {
    position: relative;
    z-index: 1;
}

.scratch-canvas {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    border-radius: 0.5rem;
}

.force-white-html :deep(*) {
    color: #fff !important;
}

.instruction-number {
    @apply bg-[#EDC516] text-black rounded-full w-[40px] h-[40px] flex items-center justify-center text-lg font-bold mr-3 flex-shrink-0 border-2 border-white
}

.combinaison-text {
    @apply uppercase text-gray-300 text-center
}

.dice-style-small {
    @apply h-[45px] md:h-[60px] w-[45px] md:w-[60px]
}

.dice-style {
    @apply h-[60px] md:h-[80px] w-[60px] md:w-[80px]
}

.blocked-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 20;
    object-fit: cover;
    border-radius: 0.5rem;
    opacity: 1;
    transition: opacity 0.1s ease-in-out;
    pointer-events: none;
}

.fade-out {
    opacity: 0;
}
</style>